var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"home-ads"}},_vm._l((_vm.$store.getters.homeAds),function(item,index){return (index <= 1)?_c('div',{key:index,staticClass:"col-2"},[_c('event-home',{attrs:{"place":"ads","item":item,"type":'mini'}})],1):_vm._e()}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }